import API, { handleRequest } from "@/api/lib/api";

export const getAllCustomersApi = (
  restaurantId,
  { page = 1, per_page = 10, status = "" } = {},
) => {
  const params = { page, per_page };
  if (status) params.status = status;

  return handleRequest(() =>
    API.get(`restaurant/${restaurantId}/customers`, { params }),
  );
};

export const searchCustomersApi = (
  restaurantId,
  { search_term = "", page = 1, per_page = 10, status = "" } = {},
) => {
  const params = { search_term, page, per_page };
  if (status) params.status = status;

  return handleRequest(() =>
    API.get(`restaurant/${restaurantId}/customers/search`, { params }),
  );
};

export const getSingleCustomerApi = (customerId) =>
  handleRequest(() => API.get(`restaurant/customers/${customerId}`));

export const getCustomerOrderHistoryApi = (
  restaurantId,
  customerId,
  {
    page = 1,
    per_page = 10,
    search_term = "",
    order_type = "",
    sort_field = "order_id",
    sort_order = "desc",
  } = {},
) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurantId}/customers/${customerId}/order-history`, {
      params: {
        page,
        per_page,
        search_term,
        order_type,
        sort_field,
        sort_order,
      },
    }),
  );

export const getCustomerPointsHistoryApi = (
  restaurantId,
  customerId,
  {
    page = 1,
    per_page = 10,
    search_term = "",
    order_type = "",
    sort_field = "created_at",
    sort_order = "desc",
  } = {},
) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurantId}/customers/${customerId}/points-history`, {
      params: {
        page,
        per_page,
        search_term,
        order_type,
        sort_field,
        sort_order,
      },
    }),
  );

export const deleteCustomerApi = (customerId) =>
  handleRequest(() => API.delete(`restaurant/customers/${customerId}`));

export const createCustomerApi = (payload) =>
  handleRequest(() => API.post(`restaurant/customers`, payload));

export const updateCustomerApi = (customerId, payload) =>
  handleRequest(() =>
    API.put(`restaurant/customers/${customerId}`, payload),
  );

export const toggleCustomerPointBaseApi = (customerId) =>
  handleRequest(() =>
    API.put(`restaurant/customers/${customerId}/toggle-point-base`),
  );

export const banCustomerApi = (customerId, payload) =>
  handleRequest(() => API.put(`restaurant/order-history/customer/${customerId}/ban`, payload));

export const activeCustomerApi = (customerId, payload) =>
  handleRequest(() =>
    API.put(`restaurant/order-history/customer/${customerId}/active`, payload),
  );

export const unbanAddressApi = (addressId) =>
  handleRequest(() =>
    API.put(`restaurant/customers/addresses/${addressId}/unban`),
  );